import * as React from 'react';
import type { SVGProps } from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>) => {
  const id = React.useId().replace(/:/g, '');
  const clipA = `Plus_svg__a-${id}`;
  const clipB = `Plus_svg__b-${id}`;
  const gradient = `Plus_svg__c-${id}`;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={43}
      height={20}
      fill='none'
      {...props}
    >
      <g clipPath={`url(#${clipA})`}>
        <rect width={43} height={20} fill='#637E5C' rx={10} />
        <g clipPath={`url(#${clipB})`}>
          <path
            fill={`url(#${gradient})`}
            d='M13.203 6.352q-.669-.359-1.558-.359H8.763q-.247 0-.247.252v8.34q0 .126.061.188.063.063.186.063h.618q.248 0 .248-.251V11.73h2.027q.902 0 1.565-.359a2.45 2.45 0 0 0 1.014-1.012q.352-.654.352-1.523c0-.579-.12-1.056-.358-1.484a2.5 2.5 0 0 0-1.027-1zm-.247 3.843q-.52.504-1.385.503H9.63v-3.66h1.94q.867 0 1.386.49t.519 1.32c0 .554-.173 1.01-.52 1.346zm4.18-4.943v9.333q0 .25-.248.251h-.556q-.248 0-.248-.251V5.252q0-.252.248-.252h.556q.248 0 .248.252m8.433 2.314v7.019q0 .25-.247.251h-.482q-.247 0-.247-.251l-.025-.793a3 3 0 0 1-.655.598 3.5 3.5 0 0 1-.872.427 3 3 0 0 1-.959.158q-.89 0-1.564-.39-.675-.39-1.039-1.113-.365-.725-.365-1.68V7.567q0-.252.248-.252h.593q.248 0 .248.252v4.126q0 1.032.556 1.635.557.604 1.484.604.606 0 1.132-.296.525-.295.834-.804.31-.51.31-1.138V7.566q0-.252.246-.252h.557q.247 0 .247.252m6.536 4.126q.303.44.303 1.069c0 .42-.103.774-.31 1.113q-.308.51-.878.817-.568.309-1.31.309-.78 0-1.479-.27t-1.242-.75q-.173-.15-.038-.352l.322-.415q.149-.19.347-.038.458.34.989.566t1.076.227a2 2 0 0 0 .779-.145q.345-.145.538-.415.19-.272.191-.635a.88.88 0 0 0-.204-.598 1.5 1.5 0 0 0-.575-.384 9 9 0 0 0-1.027-.327q-1.04-.277-1.663-.818-.624-.54-.625-1.421 0-.54.272-1 .273-.46.841-.75.57-.289 1.41-.289.582 0 1.175.208t1.013.585q.174.151.013.352l-.334.416q-.147.163-.346.025a3 3 0 0 0-.736-.403 2.3 2.3 0 0 0-.822-.15q-.742 0-1.108.289a.9.9 0 0 0-.365.742c0 .301.13.533.39.717q.39.276 1.39.553.693.188 1.2.459.506.27.81.71zM35.5 8.993v5.592a.25.25 0 0 1-.248.251h-.618a.25.25 0 0 1-.248-.251V9.127c0-1.654-1.318-2.995-2.944-2.995h-12.08a.25.25 0 0 1-.248-.252v-.628A.25.25 0 0 1 19.362 5h12.212c2.168 0 3.925 1.788 3.925 3.993'
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipA}>
          <rect width={43} height={20} fill='#fff' rx={10} />
        </clipPath>
        <clipPath id={clipB}>
          <path fill='#fff' d='M7.5 5h28v10h-28z' />
        </clipPath>
        <linearGradient
          id={gradient}
          x1={12.851}
          x2={30.856}
          y1={1.711}
          y2={19.412}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#647F5D' />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgPlus;
